import axios from 'axios'
import config from '@/config'

const labels = {
  pending: 'En attente', downloading: 'Téléchargement', validating: 'Validation', downloaded: 'Téléchargé',
  empty: 'Aucun séjour', retry_wait: 'Nouvelle tentative', failed: 'Échec', completed: 'Terminé',
  completed_with_errors: 'Terminé avec erreurs', importing: 'Import en cours', preparing: 'Préparation',
  prepared: 'Prêt à publier', publishing: 'Publication', published: 'Publié', unchanged: 'Inchangé', superseded: 'Session remplacée'
}

export function statusLabel (status) {
  return labels[status] || status || 'Non renseigné'
}

export function statusColor (status) {
  if (['failed', 'completed_with_errors'].includes(status)) return 'error'
  if (['retry_wait', 'pending', 'prepared'].includes(status)) return 'warning'
  if (['published', 'completed', 'downloaded', 'unchanged'].includes(status)) return 'success'
  if (['empty', 'superseded'].includes(status)) return 'secondary'

  return 'info'
}

export function formatNumber (value) {
  return value === null || value === undefined ? '—' : new Intl.NumberFormat('fr-FR').format(value)
}

export function formatDate (value) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'

  return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Paris' }).format(date)
}

export function formatDay (value) {
  if (!value) return '—'

  return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeZone: 'Europe/Paris' }).format(new Date(value))
}

export function formatBytes (value) {
  if (value === null || value === undefined) return '—'
  const unit = value >= 1073741824 ? 1073741824 : 1048576

  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 }).format(value / unit) + (unit === 1073741824 ? ' Gio' : ' Mio')
}

export function percentage (value, total) {
  return total > 0 ? Math.min(100, Math.max(0, value / total * 100)) : 0
}

export default {
  data: () => ({ loading: false, refreshError: null, lastUpdated: null }),
  created () {
    this.requestSequence = 0
    this.requestCancellation = null
    this.refresh()
  },
  beforeDestroy () {
    ++this.requestSequence
    if (this.requestCancellation) this.requestCancellation.cancel()
  },
  methods: {
    formatNumber, formatDate, formatDay, formatBytes, percentage, statusLabel, statusColor,
    getMonitoring (path, cancelToken, params = {}) {
      return this.$http.get(config.apiUrl + '/api/stays' + path, {
        params,
        cancelToken,
        headers: { Authorization: 'Bearer ' + this.$store.getters.getToken }
      }).then(response => response.data)
    },
    async refresh () {
      if (this.requestCancellation) this.requestCancellation.cancel()
      this.requestCancellation = axios.CancelToken.source()
      const sequence = ++this.requestSequence
      this.loading = true
      this.refreshError = null
      try {
        const data = await this.loadData(this.requestCancellation.token)
        if (sequence !== this.requestSequence) return
        Object.assign(this, data)
        this.lastUpdated = new Date().toISOString()
      } catch (error) {
        if (axios.isCancel(error) || sequence !== this.requestSequence) return
        const response = error.response
        const violations = response && response.data && response.data.violations
        this.refreshError = response && response.status === 401 ? 'Votre session a expiré. Veuillez vous reconnecter.'
          : (violations && violations[0] ? violations[0].title : 'Impossible de récupérer le suivi des séjours. Les dernières données affichées sont conservées.')
      } finally {
        if (sequence === this.requestSequence) {
          this.loading = false
        }
      }
    }
  }
}
